module.exports = __webpack_public_path__ + "static/img/病毒包装.6e9d271.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/一级标题Banner/病毒包装.jpg
// module id = Kb85
// module chunks = 16